export default "__VITE_ASSET__DMqzXGKf__"